<script setup lang="ts">
  import { computed, ref, watch, onMounted } from 'vue'
  import translaters from '../../tradutors/assine'
  import { localeStore } from '../../stores/locale'
  import { planCreditStore } from '../../stores/planscredits'
  import { planStore } from '../../stores/plans'
  import { assineChoiceStore } from '../../stores/assineChoice'
  import { event } from 'vue-gtag'
  import { useRoute } from 'vue-router'
  import api from '../../api'
  import router from '../../router'

  const storeLocale = localeStore()
  const storePlan = planStore()
  const storePlanCredits = planCreditStore()
  const storeAssineChoice = assineChoiceStore()
  const emit = defineEmits(['showModalMessages'])
  const route = useRoute()

  const reactiveVoucher = computed(() => storePlan.voucher)
  const reactiveCoupon = computed(() => storePlan.coupon)
  const reactivePlans = computed(() => storePlan.plans)
  const reactiveLocale = computed(() => storeLocale.locale)
  const reactivePlansCredits = computed(() => storePlanCredits.plansCredits)
  const reactiveAssineChoice = computed(() => storeAssineChoice)

  const form = ref(null)
  const imgQrcode = ref('')
  const copyQrcode = ref('')
  const indexValue = ref('0,00')
  const loading = ref(false)
  const acept = ref(false)
  const descriptionTerm = ref(false)

  const translate = computed(() => {
    if (reactiveLocale.value === 'pt-br') {
      return translaters.portugues
    } else {
      return translaters.ingles
    }
  })

  watch(reactiveLocale, () => {
    getTerms()
  })

  onMounted(() => {
    getTerms()
    eventGTM()
  })

  interface formCheckInterce {
    acept: boolean
  }
  function checkForm(formCheck: formCheckInterce) {
    if (!formCheck.acept) {
      error('Termos de uso é obrigatório!')
      return false
    }
    return true
  }

  function error(value) {
    emit('showModalMessages', {
      message: { show: true, title: 'Erro', textButton: 'Fechar', textBoby: value }
    })
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'erro',
      erro: {
        tipo: value
      }
    })
  }

  function getValuePlan() {
    var planId = reactiveAssineChoice.value.choiceId
    let value = '0,00'
    if (reactiveAssineChoice.value.choiceType == 'credits') {
      reactivePlansCredits.value.forEach((element) => {
        if (element.id == planId) {
          value =
            +element.discount > 0 && element.discount_value ? element.discount_value : element.value
        }
      })
    } else {
      reactivePlans.value.forEach((element) => {
        if (element.id == planId) {
          value =
            element.discount > 0 && element.discount_value
              ? String(element.discount_value)
              : element.value
        }
      })
    }
    return value
  }

  function geraQrcode(method: number) {
    event('checkout2', { method: 'Pix' })
    loading.value = true
    imgQrcode.value = ''
    copyQrcode.value = ''

    form.value = {
      locale: reactiveLocale.value,
      plan: reactiveAssineChoice.value.choiceId,
      acept: acept.value,
      method
    }

    if (checkForm(form.value)) {
      form.value.coupon = route.query.coupon ?? reactiveCoupon.value ?? ''
      form.value.voucher = route.query.voucher ?? reactiveVoucher.value ?? ''

      if (sessionStorage.getItem(`generateQrCodePix:${reactiveAssineChoice.value.choiceId}`)) {
        let info = JSON.parse(
          sessionStorage.getItem(`generateQrCodePix:${reactiveAssineChoice.value.choiceId}`)
        )
        imgQrcode.value = info.qrcode
        copyQrcode.value = info.code
        let box = document.getElementsByClassName('vcp__body') as HTMLCollectionOf<HTMLElement>
        if (box.length > 0) box[0].style.height = 'auto'
        verificandoPagamento(0)
        loading.value = false
      } else {
        var routeCheckout =
          reactiveAssineChoice.value.choiceType == 'credits'
            ? 'v1/subscribe/storeCreditsAssine'
            : 'v1/subscribe/storePaymentAssine'
        api
          .post(routeCheckout, form.value)
          .then(({ data }) => {
            if (data.process) {
              imgQrcode.value = data.info.qrcode
              copyQrcode.value = data.info.code
              let box = document.getElementsByClassName(
                'vcp__body'
              ) as HTMLCollectionOf<HTMLElement>
              if (box.length > 0) box[0].style.height = 'auto'
              eventGTMPurchase(data.orderId)
              verificandoPagamento(0)
              sessionStorage.setItem(
                `generateQrCodePix:${reactiveAssineChoice.value.choiceId}`,
                JSON.stringify(data.info)
              )
            } else {
              error(data.errors)
            }
          })
          .catch(
            ({
              response: {
                data: { errors }
              }
            }) => error(errors)
          )
          .finally(() => (loading.value = false))
      }
    } else {
      loading.value = false
    }
  }

  function verificandoPagamento(intervalPing) {
    setTimeout(function () {
      intervalPing = setInterval(function () {
        api
          .get('v1/assine/checkPixPaid')
          .then(() => {
            // this.eventGTMPurchase()

            if (reactiveAssineChoice.value.choiceType == 'credits') {
              router.push({
                name: 'CheckoutCreditsSuccessPage',
                params: {
                  locale: reactiveLocale.value
                }
              })
            } else {
              router.push({
                name: 'CheckoutSuccessPage',
                params: {
                  locale: reactiveLocale.value
                }
              })
            }
          })
          .catch(() => console.log('Pix ainda não pago...'))
      }, 5000)
    }, 10000)

    setTimeout(function () {
      clearInterval(intervalPing)
    }, 1000 * 60 * 10)
  }

  function eventGTM() {
    indexValue.value = getValuePlan()
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'add_payment_info',
      payment: {
        acionador: route.query.acionador ?? 'link direto',
        tipo: reactiveAssineChoice.value.choiceType == 'credits' ? 'Crédito' : 'Assinatura',
        valor: indexValue.value,
        currency: reactiveLocale.value === 'pt-br' ? 'BRL' : 'USD',
        forma: 'PIX'
      }
    })
  }

  function eventGTMPurchase(transaction_id) {
    indexValue.value = getValuePlan()
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'purchase',
      purchase: {
        acionador: route.query.acionador ?? 'link direto',
        tipo: reactiveAssineChoice.value.choiceType == 'credits' ? 'Crédito' : 'Assinatura',
        valor: indexValue.value,
        transaction_id,
        forma: 'PIX'
      }
    })
  }

  function getTerms() {
    api.get(`v1/subscribe/getTerms?language=${reactiveLocale.value}`).then(
      ({
        data: {
          terms: { description }
        }
      }) => {
        descriptionTerm.value = description
      }
    )
  }

  const copySuccess = ref(false)
  async function copyText() {
    try {
      await navigator.clipboard.writeText(copyQrcode.value)
      copySuccess.value = true
    } catch (err) {
      console.error('Erro ao copiar o texto: ', err)
      copySuccess.value = false
    }
  }
</script>

<template>
  <div class="container-pay">
    <div class="row my-3 justify-content-center">
      <div class="col-10">
        <span class="legend mt-3" v-html="translate.legendFormPix"></span>
      </div>
      <div class="text-center mt-3" v-if="loading">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <!--Terms BEGIN-->
      <div class="pt-3">
        <vue-collapsible-panel-group base-color="#2d2b3b">
          <vue-collapsible-panel :expanded="false">
            <template #title>
              <div class="title-terms">{{ translate.titleTermsUse }}</div>
            </template>
            <template #content>
              {{ ' ' }}
              <div class="col-12">
                <span v-html="descriptionTerm"></span>
              </div>
            </template>
          </vue-collapsible-panel>
        </vue-collapsible-panel-group>
      </div>
      <div class="pt-3 pb-3">
        <input type="checkbox" name="acept" id="acept" v-model="acept" />
        <label for="checkbox" class="acept-text">{{ translate.aceitlabel }}</label>
      </div>
      <!--Terms END-->
      <div class="col-12 mt-3 d-flex justify-content-center" v-if="!loading || imgQrcode">
        <button class="d-w-btn" type="submit" @click="geraQrcode(2)">GERAR QRCODE</button>
      </div>
      <div class="col-10 text-center mt-3" v-if="imgQrcode">
        <img class="img-pix" :src="`data:image/png;base64,${imgQrcode}`" alt="Pix" />
        <span class="copypix mt-2"> {{ copyQrcode }}</span>
        <button @click="copyText" class="copy-btn">
          Copiar
          <font-awesome-icon :icon="['fas', 'clipboard']" size="md" class="icon-copy" />
        </button>
        <p v-if="copySuccess" class="copy-success">Texto copiado com sucesso!</p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="css">
  .container-pay {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .legend {
    font-size: 12px;
    width: 50%;
    color: gray;
    text-align: center;
  }

  .img-pix {
    height: auto;
    width: auto;
  }

  .d-w-btn {
    color: #fff;
    padding: 10px 30px;
    background: #050505;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    min-width: 210px;
    align-items: center;
    font-family: 'Exo-2';
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
  }
  .copy-success {
    font-size: 10px;
    color: #b20000;
  }

  .icon-copy {
    margin-left: 5px;
  }

  .copy-btn {
    color: #fff;
    padding: 5px 15px;
    background: #050505;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    min-width: 110px;
    align-items: center;
    font-family: 'Exo-2';
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 15px;
    margin-top: 5px;
    margin-inline: auto;
  }

  .vcpg {
    border: none !important;
  }

  .vcpg :deep(.vcp__header) {
    border-radius: 10px;
    background-color: #f5f5f5 !important;
    margin-top: 10px;
    padding: 26px;
    border: 1px solid var(--border-color);
  }

  .title-terms {
    font-family: 'Exo-2';
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #0b0b0b;
  }

  .acept-text {
    font-family: 'Exo-2';
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
    color: #4b4b4b;
  }

  input[type='checkbox']:before {
    content: '';
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    top: -3px;
    left: -3px;
    background-color: unset;
  }

  input[type='checkbox']:checked:after {
    border: unset;
  }

  /* regras mobile 769px */
  @media screen and (max-width: 769px) {
  }
</style>
